import { ElementType } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Dashboard from "../../client/pages/dashboard/Dashboard";
import Patients from "../../clinic/pages/patient/Patients";
import DeactivePatient from "../../clinic/pages/patient/deactive/DeactivePatient";
import ActivePatient from "../../clinic/pages/patient/active/ActivePatient";

type Route = {
  TITLE: string;
  MAINTITLE?: string;
  ICON?: ElementType; // For React component icons
  KEY: number;
  PATH: string;
  ELEMENT?: ElementType; // For React page components like Dashboard, Employee, etc.
  DIRECT?: boolean;
  SUBNAV?: Route[]; // Recursive for nested menus
  SUBSUBNAV?: Route[]; // Further nesting if needed
};
export const NEWROUTES: Route[] = [
  {
    TITLE: "Dashboard",
    ICON: DashboardIcon,
    KEY: 1,
    PATH: "dashboard",
    ELEMENT: Dashboard,
  },
  {
    TITLE: "Patients",
    MAINTITLE: "All Patients",
    ICON: DashboardIcon,
    KEY: 3,
    PATH: "Patients",
    DIRECT: true,
    ELEMENT: Patients,
    SUBNAV: [
      {
        TITLE: "active",
        KEY: 32,
        PATH: "active",
        ELEMENT: ActivePatient,
      },
      {
        TITLE: "deactive",
        KEY: 33,
        PATH: "deactive",
        ELEMENT: DeactivePatient,
      },
    ],
  },
];
